const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "dj",
  transform: "translate(-3 -3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_23182",
  "data-name": "Path 23182",
  d: "M25.839,9.511a2.359,2.359,0,0,0,2.573,0,2.6,2.6,0,0,1,1.445-.438,1.212,1.212,0,0,1,.7.226,3.724,3.724,0,0,0-6.876,0,1.214,1.214,0,0,1,.71-.226,2.6,2.6,0,0,1,1.445.438Z",
  transform: "translate(-12.124 -2.348)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_23183",
  "data-name": "Path 23183",
  d: "M26.724,21.035a3.729,3.729,0,0,0,3.724-3.724,7.228,7.228,0,0,0-.372-2.288l-.253-.758A.386.386,0,0,0,29.456,14a1.774,1.774,0,0,0-.987.3,3.2,3.2,0,0,1-3.492,0,1.774,1.774,0,0,0-.983-.3.386.386,0,0,0-.367.264l-.254.758A7.228,7.228,0,0,0,23,17.311,3.729,3.729,0,0,0,26.724,21.035Z",
  transform: "translate(-11.723 -6.448)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_23184",
  "data-name": "Path 23184",
  d: "M29.06,32.589a1.241,1.241,0,0,0,2.433,0A4.437,4.437,0,0,1,29.06,32.589Z",
  transform: "translate(-15.275 -17.344)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_23185",
  "data-name": "Path 23185",
  d: "M29.692,33.157a22.327,22.327,0,0,0-6.774-2.8L22.67,30.3a4.593,4.593,0,0,1-.91.614V31a2.069,2.069,0,1,1-4.138,0v-.089c-.033-.017-.067-.031-.1-.048a34.9,34.9,0,0,0-5.043,1.907A6.2,6.2,0,0,1,11,34.425v2.787h3.311a.414.414,0,0,1,.414.414V41.35h3.452l.967-2.256-1.676-.67a.414.414,0,0,1-.173-.639l2.9-3.724a.414.414,0,0,1,.741.254V37.3l1.342.336a.414.414,0,0,1,.244.631L20.463,41.35h3.456l.447-1.793a2,2,0,0,1,.7-1.081V37.212a.414.414,0,0,1,.414-.414h1.289a17.67,17.67,0,0,1,2.919-3.642Z",
  transform: "translate(-4.689 -16.004)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_23186",
  "data-name": "Path 23186",
  d: "M29.4,48.743h.393l2.034-3.052-1.086-.271a.414.414,0,0,1-.313-.4v-2.1L28.6,45.253l1.559.623a.414.414,0,0,1,.226.547Z",
  transform: "translate(-15.009 -23.396)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5404",
  "data-name": "Rectangle 5404",
  width: 19.036,
  height: 0.828,
  transform: "translate(5.483 26.175)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_23187",
  "data-name": "Path 23187",
  d: "M5.483,27.172c-.077.041-.149.091-.229.131l-.37-.743a5.4,5.4,0,0,0,2.866-3.671l.121-.543a2.069,2.069,0,0,1,.558-1.016,1.251,1.251,0,0,0,.137-.17,1.645,1.645,0,0,1-.6-1.263V18.241A1.646,1.646,0,0,1,8.428,17.1a.358.358,0,0,0-.246-.1.369.369,0,0,0-.362.29L7.129,20.4a.411.411,0,0,1-.076.163L3.491,25.194A2.365,2.365,0,0,0,5.366,29h.118Z",
  transform: "translate(0 -8.206)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_23188",
  "data-name": "Path 23188",
  d: "M50.741,38.887l-.153-.111c-.22-.161-.446-.311-.67-.463a16.874,16.874,0,0,0-3.236,4.138l-.5.9a.414.414,0,0,1-.362.213,1.174,1.174,0,0,0-1.141.891l-.4,1.592H45.2l.562-.75a9.844,9.844,0,0,0,.927-1.5.414.414,0,0,1,.207-.2l.579-.248a8.049,8.049,0,0,0,3.535-2.941,1.115,1.115,0,0,0-.272-1.52Z",
  transform: "translate(-24.197 -20.699)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_23189",
  "data-name": "Path 23189",
  d: "M24.38,3.828A4.558,4.558,0,0,1,28.932,8.38h.828A5.38,5.38,0,0,0,19,8.38h.828A4.558,4.558,0,0,1,24.38,3.828Z",
  transform: "translate(-9.378 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_23190",
  "data-name": "Path 23190",
  d: "M17.828,21.311h1.144a4.522,4.522,0,0,1-.316-1.655A8.045,8.045,0,0,1,18.833,18H17.828a.828.828,0,0,0-.828.828v1.655A.828.828,0,0,0,17.828,21.311Z",
  transform: "translate(-8.206 -8.793)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_23191",
  "data-name": "Path 23191",
  d: "M42.374,18a8.045,8.045,0,0,1,.178,1.655,4.522,4.522,0,0,1-.316,1.655H43.38a.828.828,0,0,0,.828-.828V18.828A.828.828,0,0,0,43.38,18Z",
  transform: "translate(-22.999 -8.793)",
  fill: "#fff"
}));
function SvgArtistsSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.002,
    viewBox: "0 0 24 24.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtistsSelected);
export default __webpack_public_path__ + "static/media/artistsSelected.147d1057d75670354648cd1967a35691.svg";
export { ForwardRef as ReactComponent };